import clsx from "clsx";
import PropTypes from "prop-types";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export const DropdownFilter = ({
  className,
  data,
  value,
  disabled,
  onOptionSelected,
  placeholder = "activity type",
}) => {
  return (
    <Dropdown
      onOptionSelected={onOptionSelected}
      className={clsx("documents-activity-filter", className)}
      selected={value}
      disabled={disabled}
      filled
    >
      <DropdownButton placeholder={placeholder} clearEnabled>
        {value?.name}
      </DropdownButton>
      <DropdownItems>
        {data.map((option) => (
          <DropdownItem key={option.id} value={option}>
            {option.name}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};

DropdownFilter.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  value: PropTypes.object,
  disabled: PropTypes.bool,
  onOptionSelected: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
